<div class="text-center mt-5">
  <div class="center_div">
    <div class="container">
      <form [formGroup]="updateForm" (ngSubmit)="updateCourse()">
        <h2 class="text-center text-primary">Editar Curso</h2>
        <hr>
        <div class="form-group">
          <input type="text" [(ngModel)]="course.Name"
          [ngClass]="{'is-invalid': updateForm.get('Name').errors && updateForm.get('Name').touched }"
          class="form-control" formControlName="Name" placeholder="Nombre">
          <div class="invalid-feedback">Porfavor ingrese el nombre del curso</div>
        </div>

        <div class="form-group">
          <textarea [(ngModel)]="course.Description" class="form-control"  rows="3" [ngClass]="{'is-invalid': updateForm.get('Description').errors && updateForm.get('Description').touched }"
          class="form-control" formControlName="Description" placeholder="Descripción"></textarea>
          <div class="invalid-feedback">Porfavor agregue una descripción</div>
        </div>

        <div class="form-group">
          <input [(ngModel)]="course.Price" type="text"  (keypress)="onlyNumberKey($event)" maxlength="3"
          [ngClass]="{'is-invalid': updateForm.get('Price').errors && updateForm.get('Price').touched }"
          class="form-control" formControlName="Price" placeholder="Precio">
          <div class="invalid-feedback">Porfavor asigne un precio al curso</div>
        </div>

        <div class="form-group">
          <input [(ngModel)]="course.Duration" type="text"
          [ngClass]="{'is-invalid': updateForm.get('Duration').errors && updateForm.get('Duration').touched }"
          class="form-control" formControlName="Duration" placeholder="Duración del curso">
          <div class="invalid-feedback">Porfavor agregue una duración</div>
        </div>
        
        <div class="form-group">
          <input [(ngModel)]="course.Modality" type="text"
          [ngClass]="{'is-invalid': updateForm.get('Modality').errors && updateForm.get('Modality').touched }"
          class="form-control" formControlName="Modality" placeholder="Modalidad">
          <div class="invalid-feedback">La modalidad no puede estar vacia</div>
        </div>
        
        <div class="form-group">
          <div class="custom-control custom-switch">
            <input [(ngModel)]="course.Active" formControlName="Active" type="checkbox" class="custom-control-input" id="customSwitches">
            <label class="custom-control-label" for="customSwitches">Activo</label>
          </div>
        </div>
        
        <div class="form-group">
          <select [(ngModel)]="course.CourseType" class="custom-select" [ngClass]="{'is-invalid': updateForm.get('CourseType').errors && updateForm.get('CourseType').touched }"
          class="form-control" formControlName="CourseType" placeholder="Selecione un tipo">
          <option [value]="courseType.idCourseType" *ngFor="let courseType of courseTypes">{{courseType.Name}}</option>
          </select>
          <div class="invalid-feedback">Porfavor selecione un tipo</div>
        </div>
        
        <div class="">
          <h4 class="text-center">Exámenes</h4>
          <div class="d-flex w-100">
            <div class="form-group d-flex w-100">
              <select class="custom-select" id="Level" (change)="onChangeLevel($event.target.value)"
              class="form-control">
              <option hidden [value]="0" >Nivel</option>
              <option [value]="level.idLevel" *ngFor="let level of levels">{{level.LevelName}}</option>
              </select>

              <select class="custom-select" id="Classification" (change)="onChangeClassification($event.target.value)"
               class="form-control">
               <option hidden [value]="0" >Clasificación</option>
                <option [value]="classification.idClassification" 
                        *ngFor="let classification of Classifications">
                        {{classification.ClassificationName}}
                </option>
              </select>

              <select id="ExamSelect" class="custom-select" class="form-control">
                <option hidden [value]="0" selected>Examen</option>
                <option [value]="exam.idExams" 
                        *ngFor="let exam of exams">
                        {{exam.Name}}
                </option>
              </select>
              <button class="btn btn-success ml-3" type="button" (click)="addExam()"><i class="fa fa-plus"></i></button>
            </div>
            
          </div>
        </div>

        <div class="form-group">
          <div *ngFor="let item of getFormArray().controls | keyvalue; let i = index" formArrayName="CourseExams">
            <div [formGroupName]="item.key">
              <div class="form-group d-flex w-100">
                <div class="w-100">
                  {{updateForm.get('CourseExams').get(item.key).get('examName').value}}
                </div>
                <button class="btn btn-danger ml-3" type="button" (click)="removeExam(item.key)"><i class="fa fa-minus"></i></button>
              </div>  
            </div>
          </div>
        </div>
        
        <div class="form-group text-center">
          <button class="btn btn-success" [disabled]="!updateForm.dirty || !updateForm.valid" type="submit">Actualizar</button>
          <button class="btn btn-default" type="button" [routerLink]="['/courses']">Cancelar</button>
        </div>
      </form>
    </div>
  </div>
</div>
